const ORGANIZATION_USER_STATUSES = {
  activeInvite: 'active',
  pendingInvite: 'pending',
  expiredInvite: 'expired'
};

const ORGANIZATION_USER_STATUS_LIST = Object.values(ORGANIZATION_USER_STATUSES);

export { ORGANIZATION_USER_STATUSES, ORGANIZATION_USER_STATUS_LIST };
